<scope-departments-header
  *ngIf="component.departments?.length > 0 && !config?.isTimeline"
  [config]="config"
  [level]="level">
</scope-departments-header>

<scope-departments-row
  *ngFor="let department of component.departments; trackBy: trackById"
  [component]="component"
  [department]="department"
  [config]="config"
  [level]="level"
  (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)"
  (onUpdateRole)="onUpdateRole.emit($event)">
</scope-departments-row>
